var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import Vue from 'vue';
import Component from 'vue-class-component';
import { namespace } from 'vuex-class';
import BreakInDamageDescriptionSectionCard from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionSectionCard.vue';
import BreakInDamageDescriptionStep from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionStep.vue';
import BreakInDamagePicturesSection from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamagePicturesSection.vue';
import RadioPrimaryButton from '@declaration/components/UI/RadioPrimaryButton.vue';
import { YES_OR_NO_CHOICES } from '@declaration/helpers/choices';
import BreakInDamageDescriptionSubSection from '@declaration/components/breakInDamage/DamageDescription/UI/BreakInDamageDescriptionSubSection.vue';
import { parseLength } from '@declaration/helpers/typeFormatters';
import OutlinedNumberInput from '@declaration/components/OutlinedNumberInput.vue';
const layout = namespace('layout');
const breakInDamage = namespace('breakInDamage');
let ShutterOtherDamages = class ShutterOtherDamages extends Vue {
    constructor() {
        super(...arguments);
        this.parseLength = parseLength;
        this.isSaving = false;
        this.showValidation = false;
        this.YES_OR_NO_CHOICES = YES_OR_NO_CHOICES;
    }
    get change() {
        return this.changeGetter(this.changeKey);
    }
    get breakInDamage() {
        return this.change.data;
    }
    get validation() {
        return this.validationGetter(this.changeKey);
    }
    get isValid() {
        let validation = !this.validation.fieldHasViolations('hasOtherDamages');
        if (this.breakInDamage.hasOtherDamages) {
            validation = validation && !this.validation.fieldHasViolations('otherDamages');
        }
        return validation;
    }
    update(data) {
        this.updateBreakInDamage({ changeKey: this.changeKey, data });
    }
    save() {
        this.isSaving = true;
        this.$emit('goToNextStep');
        this.isSaving = false;
    }
    revealValidation() {
        this.$store.dispatch('error/add', this.$tc('error.form.please_validate_message'));
        this.validateBreakInDamage(this.changeKey);
        this.showValidation = true;
    }
    get displayOtherDamageQuestion() {
        return this.breakInDamage.hasOtherDamages;
    }
};
__decorate([
    layout.State('color')
], ShutterOtherDamages.prototype, "color", void 0);
__decorate([
    breakInDamage.Getter('change')
], ShutterOtherDamages.prototype, "changeGetter", void 0);
__decorate([
    breakInDamage.Action('updateDamage')
], ShutterOtherDamages.prototype, "updateBreakInDamage", void 0);
__decorate([
    breakInDamage.Getter('validation')
], ShutterOtherDamages.prototype, "validationGetter", void 0);
__decorate([
    breakInDamage.Action('validateAndRevealDamages')
], ShutterOtherDamages.prototype, "validateBreakInDamage", void 0);
ShutterOtherDamages = __decorate([
    Component({
        components: {
            OutlinedNumberInput,
            BreakInDamagePicturesSection,
            BreakInDamageDescriptionStep,
            BreakInDamageDescriptionSectionCard,
            RadioPrimaryButton,
            BreakInDamageDescriptionSubSection,
        },
        props: {
            changeKey: { type: [String, Number], default: null },
            isFinalStep: { type: Boolean, default: false },
        },
    })
], ShutterOtherDamages);
export default ShutterOtherDamages;
